import { handleSearchParams } from "src/utils"
import { APICall } from ".."

const ControllerName = "MobDoctorRequests"

export const GetApprovalRequest = (searchParams: any, tableFiller: any) => {
    const searchData = handleSearchParams(searchParams, tableFiller)

    return APICall("get", ControllerName + `/approvals${searchData}`)
}

export const GetMedicineChangeRequests = (searchParams: any, tableFiller: any) => {

    const searchData = handleSearchParams(searchParams, tableFiller)

    return APICall("get", ControllerName + `/medicinesChangeRequests${searchData}`)
}

export const GetDoctorRequestMedicine = (requestId: number) => {


    return APICall("get", ControllerName + `/medicines/${requestId}`)
}

export const ApproveDoctorMedicineRequest = (data: any) => {
    return APICall("post", ControllerName + "/approve", data)
}

export const ChangeDoctorMedicineRequest = (data: any) => {
    return APICall("post", ControllerName + "/changeMedicines", data)
}